import type { CmsApiPost } from '#/modules/cms/api/types/CmsApiDocument';
import { CommentButton } from '#/modules/cms/components/Reactions/CmsReactionsCommentButton';
import { ShareButton } from '#/modules/cms/components/Reactions/CmsReactionsShareButton';

export function CmsButtonBar({ content }: { content: CmsApiPost }) {
  return (
    <>
      {content.enableComments ? <CommentButton /> : null}
      {content.hasSocialSharing ? <ShareButton content={content} /> : null}
    </>
  );
}
